module.exports = __webpack_public_path__ + "static/bg-transportation-cd0da44af790f92c8801c45c56da66af.jpg";